<button class="btn btn-link" (click)="closeButtonClick()">
  <i class="fa fa-arrow-left mr-2"></i>
  <span *ngIf="pageName$ | async; let pageName; else default">Back to {{ pageName }}</span>
  <ng-template #default><span>Back to Media Ratings Terminal</span></ng-template>
</button>
